import { en } from 'locals/build/en';
import { ja } from 'locals/build/ja';
import { ids } from 'locals/build/id';

export interface Locales {
  [key: string]: {
    locale: string;
    messages: {
      [key: string]: string;
    };
    formats: {
      date: {
        default: {
          [key: string]: string;
        };
      };
      time: {
        default: {
          [key: string]: string | boolean;
        };
      };
    };
  };
}

export const locales: Locales = {
  en: {
    ...en,
    formats: {
      date: {
        default: {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        },
      },
      time: {
        default: {
          hour12: false,
        },
      },
    },
  },
  ja: {
    ...ja,
    formats: {
      date: {
        default: {},
      },
      time: {
        default: {},
      },
    },
  },
};

export const localeIds = ids;
